import {
  Directive,
  inject,
  input
} from '@angular/core';

import { TabComponent } from './tab.component';

import type { InputSignal } from '@angular/core';

@Directive({
  selector: 'td-wb-tab[tdWbTabStateName]'
})
export class TabStateNameDirective<T> {
  readonly stateName: InputSignal<string> = input<string>('', { alias: 'tdWbTabStateName' });
  readonly stateParams: InputSignal<{ [key: string]: string }> = input<{ [key: string]: string }>(undefined, { alias: 'tdWbTabStateParams' });

  private readonly tabComponent: TabComponent<T> = inject(TabComponent, { host: true });

  getTabId(): T {
    return this.tabComponent.getTabId();
  }

  getStateName(): string {
    return this.stateName() === '' ? undefined : this.stateName();
  }

  getStateParams(): { [key: string]: string } {
    return this.stateParams();
  }
}
